// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    UNSUBSCRIBED_CONTACT_DELETE_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    deleteUnsubscribedContactResult,
} from 'Redux/actions';

// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* deleteUnsubscribedContact({ payload }) {
    try {
        const { items } = payload;
        
        let ids = items.map((item) => item.id)

        let QUERY = `
            mutation deleteUnsubscribedContact ($ids: [Int]!) {
                result: deleteUnsubscribedContact (ids: $ids)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                ids
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data) yield put(deleteUnsubscribedContactResult(data?.result))
        else yield put(deleteUnsubscribedContactResult({ error: true }))


    } catch (exc) {
        ExceptionManager(
            exc,
            'Modules/unsubscribedContacts/.components/deleteUnsubscribedContact/redux/saga',
            'deleteUnsubscribedContact'
        );
        put(deleteUnsubscribedContactResult({ error: true }))
    }
}

function* watchMethods() {
    yield takeEvery(UNSUBSCRIBED_CONTACT_DELETE_REQUEST, deleteUnsubscribedContact);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}